import React from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
// import Typography from '@mui/material/Typography';

import OperationForm from './OperationForm';

export default function ConfSetServer(props, context) {
  const [open, setOpen] = React.useState(false);
  const [selectedServer, setSelectedServer] = React.useState(0);

  function askBeforSubmit(params) {
    setSelectedServer(params.server);
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }

  function submitValue() {
    handleClose();
    props.updateConfig({ server: selectedServer })
  }

  return (
    <React.Fragment>

      <OperationForm
        enable={props.enable}
        fields={props.fields}
        onSubmit={askBeforSubmit}
      />

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='md'
      >
        {/* <DialogTitle>
          <Typography component='h1'>{context.t('You are about to take a significant action')}</Typography>
        </DialogTitle> */}
        <DialogContent>
          <DialogContentText style={{fontSize: 'large', color: 'black', textAlign: 'center'}}>
            {context.t('you_are_about_to_take_a_significant_action_on_num_devices', { num: props.countSelected })}<br/>
            <span style={{fontSize: 'medium', color: '#606060'}}>{context.t('confirm_updating_devices_server')}</span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={handleClose} autoFocus>{context.t('cancel')}</Button>
          <Button color="primary" onClick={submitValue} autoFocus>{context.t('continue')}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

ConfSetServer.propTypes = {
  enable: PropTypes.bool,
  updateConfig: PropTypes.func
};

ConfSetServer.contextTypes = {
  t: PropTypes.func.isRequired
};
